import React from 'react'

const EditNewIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M16.68 3.9601L5.28001 15.3001L3.60001 20.4001L8.70001 18.7201L16.68 10.7401L15.84 9.9001L8.70001 16.9801L7.02001 15.3001L15 7.3201L17.52 9.8401L20.04 7.3201C20.52 6.8401 20.52 6.1201 20.04 5.6401L18.36 3.9601C17.88 3.4801 17.1 3.4801 16.68 3.9601ZM7.74001 17.7601L6.48001 18.1801L5.82001 17.5201L6.24001 16.2601L7.74001 17.7601ZM15.84 6.5401L17.52 8.2201L19.2 6.4801L17.52 4.8001L15.84 6.5401Z"
            fill="#0562D2"
        />
    </svg>
)

export default EditNewIcon
